
import { Button, ComponentStyle} from '@/imports-files/components/delete-candidate-modal';
import { closeJob, REDIRECT}  from '@/imports-files/pages/clients/candidates/kanban';
import Modal from '@/components/common-modal/modal';


export function SkipModal({setBtnPopup, router})
{
  return(
      <Modal
        type="confirmation"
        className={`CandidateFilterModal`}
        noCloseIcon = {true}
        message={`Are you sure you want to skip this step?`}
        texts={{
          button1_text: "Cancel",
          button2_text: "Continue Skip",
        }}
        closeModal={() => setBtnPopup(false)}
        btnAction={() => {
          router.push(REDIRECT.client.activities)
        }}
      />
          // <div className = {`CandidateFilterModal ${ComponentStyle.DeleteCandidateModal}`}>
          //   <div className={`height400 width600 ${ComponentStyle.DeleteCandidateModal__Inner}`}>
          //   <div className={`confirmcontainer ${ComponentStyle.DeleteCandidateModal__Container}`}>
          //         <span className={`normalweight ${ComponentStyle.DeleteCandidateModal__Message}`}>Are you sure you want to skip this step?</span>
          //         <div className={ComponentStyle.DeleteCandidateModal__ButtonSection}>
          //         <Button buttonstyle={ComponentStyle.primarybtn} onClick={() => setBtnPopup(false)}> Cancel </Button>
          //           <Button buttonstyle={ComponentStyle.secondarybtn} onClick={()=> router.push(REDIRECT.client.activities)}> Continue Skip  </Button>
          //         </div>
          //     </div>
          //   </div>
          // </div>
        )
} 

